import React from 'react';
import { Product } from 'types/product';
import ProductItemModule from './ProductItemModule';
import List from 'components/list/List';

type ProductListModuleProps = {
  products: Product[];
};

const ProductListModule: React.FC<ProductListModuleProps> = ({ products }) => {
  return (
    <List>
      {products.map(product => (
        <ProductItemModule key={product.id} product={product} />
      ))}
    </List>
  );
};

export default ProductListModule;
